/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListDirectoryRoleMappings } from "../funcs/accessListDirectoryRoleMappings.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListDirectoryRoleMappingsResult } from "../models/components/listdirectoryrolemappingsresult.js";
import {
  ListDirectoryRoleMappingsRequest,
  ListDirectoryRoleMappingsSecurity,
} from "../models/operations/listdirectoryrolemappings.js";
import { unwrapAsync } from "../types/fp.js";
export type DirectoryRoleMappingsQueryData = ListDirectoryRoleMappingsResult;

export function prefetchDirectoryRoleMappings(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListDirectoryRoleMappingsRequest | undefined,
  security?: ListDirectoryRoleMappingsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDirectoryRoleMappingsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDirectoryRoleMappingsQuery(
  client$: GramCore,
  request?: ListDirectoryRoleMappingsRequest | undefined,
  security?: ListDirectoryRoleMappingsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<DirectoryRoleMappingsQueryData>;
} {
  return {
    queryKey: queryKeyDirectoryRoleMappings({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function directoryRoleMappingsQueryFn(
      ctx,
    ): Promise<DirectoryRoleMappingsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListDirectoryRoleMappings(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDirectoryRoleMappings(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listDirectoryRoleMappings", parameters];
}
